import { BaseAngularComponent } from "@memberjunction/ng-base-types";

/**
 * Base class for all MJ Explorer navigation components - a navigation component is any component that can be displayed from a route
 */
export abstract class BaseNavigationComponent extends BaseAngularComponent {

}